import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { ApContentModule, ApContentService } from '@ap/content';
import { ApError, ApErrorModule } from '@ap/error';

import { BetaalverzoekErrorType, ErrorData } from '../../betaalverzoek.model';

import content from './error-page.content.json';

/**
 * @ngdoc component
 * @name ErrorPageComponent
 *
 * @description
 * Component that provides functionality for the error page
 */
@Component({
    selector: 'error-page',
    templateUrl: './error-page.component.html',
    imports: [ApErrorModule, ApContentModule, RouterModule]
})
export class ErrorPageComponent implements OnInit {
    public apError: ApError;
    private readonly errorData: ErrorData;

    public constructor(
        private readonly contentService: ApContentService,
        private readonly titleService: Title
    ) {
        this.errorData = history.state.data;
    }

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        if (this.errorData) {
            this.apError = this.generateAndDisplayApError(this.errorData);
        } else {
            this.apError = this.generateAndDisplayApError({
                errorType: BetaalverzoekErrorType.APPLICATION_GENERIC_ERROR,
                showReloadOption: false
            });
        }
    }

    private generateAndDisplayApError(errorData: ErrorData): ApError {
        const title = this.contentService.get(`error-page.${errorData.errorType}.title`);
        const message = this.contentService.get(`error-page.${errorData.errorType}.message`);
        this.titleService.setTitle(title);
        return new ApError(message, null, null, errorData.showReloadOption, title);
    }
}
